import React from 'react'
import { Button } from 'reactstrap'
import { ReportSubmissionState } from '@/enums/ReportSubmissionState'
import LoadingIndicator from '@/components/LoadingIndicator'

class ReportSubmissionDetailButtons extends React.Component {
  isEditEnabled () {
    const { state, idle } = this.props
    return state === ReportSubmissionState.enum.Finished &&
      (state !== ReportSubmissionState.enum.Accepted || state !== ReportSubmissionState.enum.Sent) && idle
  }
  isFinishEnabled () {
    const { state, idle } = this.props
    return (
      (state === ReportSubmissionState.enum.Unfinished || state === ReportSubmissionState.enum.Rejected) && idle
    )
  }
  render () {
    if (this.props.updating === true) { return (<LoadingIndicator inline />) }

    const { localize, readonly } = this.props
    return (
      <React.Fragment>
        <Button disabled={!this.isEditEnabled() || readonly} color='primary' onClick={() => this.props.onEditClicked()}>{localize('Common.Edit')}</Button>{' '}
        <Button disabled={!this.isFinishEnabled() || readonly} color='primary' onClick={() => this.props.onFinishClicked()}>{localize('Common.Finish')}</Button>
      </React.Fragment>
    )
  }
}

export default ReportSubmissionDetailButtons



// WEBPACK FOOTER //
// ./src/report-app/pages/reporting/submissions/detail/reportSubmissionDetailButtons.js